import {
  Payment as PaymentIcon,
  AssignmentOutlined,
  Groups,
  AccountBalanceWallet,
  CreditCard,
  Assessment,
  Settings as SettingsIcon,
  CardMembership,
} from '@mui/icons-material';
import { RESOURCES, ACTIONS } from '../../../hooks/useAccessControl';

export const feesMenu = {
  id: 'fees',
  label: 'Fee Management',
  icon: PaymentIcon,
  permission: { resource: RESOURCES.FEES.MANAGEMENT, action: ACTIONS.READ },
  children: [
    {
      type: 'group',
      id: 'fees-setup',
      label: 'Setup',
      children: [
        {
          id: 'fees-types',
          label: 'Fee Types',
          icon: AssignmentOutlined,
          permission: { resource: RESOURCES.FEES.TYPES, action: ACTIONS.READ },
        },
        {
          id: 'fees-groups',
          label: 'Fee Groups',
          icon: Groups,
          permission: { resource: RESOURCES.FEES.GROUPS, action: ACTIONS.READ },
        },
      ],
    },
    {
      type: 'group',
      id: 'fees-transactions',
      label: 'Transactions',
      children: [
        {
          id: 'fees-allocate',
          label: 'Allocate Fees',
          icon: AccountBalanceWallet,
          permission: { resource: RESOURCES.FEES.ALLOCATIONS, action: ACTIONS.READ },
        },
        {
          id: 'fees-payments',
          label: 'Payments',
          icon: CreditCard,
          permission: { resource: RESOURCES.FEES.PAYMENTS, action: ACTIONS.READ },
        },
        {
          id: 'fees-reports',
          label: 'Reports',
          icon: Assessment,
          permission: { resource: RESOURCES.FEES.REPORTS, action: ACTIONS.READ },
        },
      ],
    },
    {
      type: 'group',
      id: 'fees-clearance',
      label: 'Clearance',
      children: [
        {
          id: 'fees-clearance-settings',
          label: 'Clearance Settings',
          icon: SettingsIcon,
          permission: { resource: RESOURCES.CLEARANCE, action: ACTIONS.READ },
        },
        {
          id: 'fees-clearance-cards',
          label: 'Clearance Cards',
          icon: CardMembership,
          permission: { resource: RESOURCES.CLEARANCE, action: ACTIONS.READ },
        },
      ],
    },
  ],
};
